<template>
    <div id="markets">
        <div v-for="market in playersMarkets.markets" :key="market.id" :value="market.id">
            <h6 style='font-weight: bold;'>{{ market.name }}</h6>

            <table class="table">
                <tr v-for="book in market.books" :key="book.id" :value="book.id">
                    <td>
                        {{ book.name }}	
                        <br> {{ book.id }}
                    </td>
                    <td>
                        <div v-for="outcome in book.outcomes" style="border-bottom:1px solid #ccc;">
                            type: {{ outcome.type }}
                            <br> player name: {{ outcome.player_name }}
                            <br> decimal odds: {{ outcome.odds_decimal }}
                            <br> american odds: {{ outcome.odds_american }}
                            <br> fraction odds: {{ outcome.odds_fraction }}
                        </div>
                    </td>
                </tr>
            </table>	
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlayersMarkets',
    props: {
        playersMarkets: ''
    },
    data: function() {
        return {            
            
        }
    }, 
    created: function() {

	},
}
</script>

